<template>
  <div class="notfound-page">
    <div class="page-cover anim" :style="{backgroundImage: `url(${publicPath}frontend-assets/img/cover-services.jpg)`}" data-effect="fadeIn" data-duration="2s">
    </div>
    <mu-breadcrumbs class="breadcrumbs white anim" data-effect="fadeInUp" data-duration="2s">
      <mu-breadcrumbs-item :to="{ params: {locale}, name: 'home' }">{{$t('nav.home')}}</mu-breadcrumbs-item>
      <mu-breadcrumbs-item disabled>{{$t('notFound.title')}}</mu-breadcrumbs-item>
    </mu-breadcrumbs>

    <mu-container class="container">
      <div class="content anim" data-effect="fadeInUp" data-duration="2s">
        <div class="code">404</div>
        <h1 class="title">{{$t('notFound.title')}}</h1>
        <p v-for="(item, index) in $t('notFound.desc')" :key="index">{{ item }}</p>
        <router-link class="home-btn" :to="{ params: {locale}, name: 'home' }">{{$t('notFound.back')}}</router-link>
      </div>
    </mu-container>
  </div>
</template>

<script>
import animateEle from '@/simple.animate';

export default {
  name: 'NotFoundPage',
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.$store.commit('toggleLoadingScene', 100);
    this.$nextTick(() => {
      animateEle(0);
    });
  },
  mounted() {
    this.$store.commit('toggleLoadingScene', 100);
    this.$nextTick(() => {
      animateEle(0);
    });
  },
};
</script>

<style lang="less" scoped>
@import '../styles/vars.less';

.notfound-page {
  padding-bottom: 60px;
}

.page-cover {
  width: 100%;
  height: 0;
  padding-top: 42.71%;
  background-color: #000;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.breadcrumbs {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.sm, .xs {
  .breadcrumbs {
    padding-top: 100px;
  }
}

.container {
  @media (min-width: 1200px) {
    max-width: 960px;
  }
  @media (min-width: 1700px) {
    max-width: 1500px;
  }
}

.content {
  padding-top: 60px;
  padding-bottom: 40px;
  text-align: center;
  color: @black;

  .code {
    font-size: 96px;
    line-height: 1;
    font-weight: bold;
    color: @keyColor;
    margin-bottom: 24px;
  }

  .title {
    font-size: 24px;
    line-height: 1.5;
    font-weight: bold;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    line-height: 1.75;
    margin: 0 0 6px;
  }

  .home-btn {
    display: inline-block;
    margin-top: 30px;
    padding: 10px 30px;
    color: @black;
    text-decoration: none;
    border: 1px solid @keyColor;
    transition: all 0.3s;

    &:hover {
      color: @white;
      background-color: @keyColor;
    }
  }
}

.xs, .sm {
  .content {
    padding-top: 40px;

    .code {
      font-size: 64px;
      margin-bottom: 16px;
    }
  }
}
</style>
